export type KnownCardSystem = 'visa' | 'mastercard' | 'mir' | 'maestro'
export type CardSystem = KnownCardSystem | 'unknown'
export type PaymentType = 'card' | 'contract'

type AbstractPayment<T extends PaymentType> = {
  __type: T
}

export type PaymentCard = AbstractPayment<'card'> & {
  id: string
  system: CardSystem
  number: string
  expirationDate?: string
}

export const enum PaymentContractErrorCode {
  /**
   * Долг по карте
   */
  OutstandingDebt = 'outstandingDebt',
  /**
   * Договор не активен
   */
  InactiveContract = 'inactiveContract',
  /**
   * Договор не подтвержден в балансе
   */
  OfferNotAccepted = 'offerNotAccepted',
  /**
   * Здесь договор еще создается, надо подождать
   */
  BalanceNotFoundForPrepaid = 'balanceNotFoundForPrepaid',
  /**
   * Недостаточно денег на договоре
   */
  InsufficientBalance = 'InsufficientBalance',
  /**
   * Договор не активен
   */
  DisabledContract = 'disabledContract',
  /**
   * Регистрация не завершена
   */
  NotIsRegistered = 'notIsRegistered',
  /**
   * в Израиле нужно прикреплять карту к договору. Ошибка возникает, если карты нет.
   */
  CardForDirectDebitingIsMissing = 'cardForDirectDebitingIsMissing',
  /**
   * Договор создается
   */
  ContractIsPending = 'contractIsPending',
  /**
   * Неизвестная ошибка. Ее срочно нужно поддержать тут
   */
  Unknown = 'unknown',
}

export const enum PaymentContractPaymentType {
  Prepaid = 'prepaid',
  Postpaid = 'postpaid',
  Unknown = 'unknown',
}

export const enum PaymentContractType {
  Offer = 'offer',
  Paper = 'paper',
  Unknown = 'unknown',
}

export type PaymentContract = AbstractPayment<'contract'> & {
  id?: string
  internalID?: string
  balance: number
  threshold: number
  errorCode?: PaymentContractErrorCode
  currencySign?: string
  type: PaymentContractType
  paymentType: PaymentContractPaymentType
  penalty?: number
  activationPaymentAmount?: number
  debtAmount?: number
  isBalanceBelowThreshold(): boolean
  isPending(): boolean
}

export type Payment = PaymentCard | PaymentContract
